import React from 'react'
import { useWillPipe } from '@morningtrain/react-helpers'
import { Env } from '@morningtrain/helpers'

export default function WaitUntilLogoutExpirationOnPipe (props) {
  const {
    expireAfter = 40
  } = props

  const resolveAfterSeconds = (payload) => {
    return new Promise(function (resolve, reject) {
      setTimeout(() => {
        const inactivityTime = Env.get('inactivity_time', 0)

        if (inactivityTime > expireAfter) {
          return resolve(payload)
        }

        return reject()
      }, expireAfter * 1000)
    })
  }

  useWillPipe(function (payload) {
    return resolveAfterSeconds(payload)
  })

  return null
}
